import { Component, OnInit, Output,Input, EventEmitter  } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from '../data.service';
import { ActivatedRoute } from "@angular/router";
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-crearusuario',
  templateUrl: './crearusuario.component.html',
  styleUrls: ['./crearusuario.component.css']
})
export class CrearusuarioComponent implements OnInit {
  usuarioForm: FormGroup;
  @Input() IdEncuesta: string | null = null; 
  @Input() IdUsuario: string | null = null; 
  @Input() Usuario: any; 
  @Output() creacionFinalizada = new EventEmitter<void>();

  constructor(private fb: FormBuilder, private data: DataService, private route: ActivatedRoute, private messageService: MessageService) {
    this.usuarioForm = this.fb.group({
      Email: ['', [Validators.required]],
      Nombre: ['', [Validators.required]],
      Crear: [true, [Validators.required]],
      Eliminar: [false, [Validators.required]],
      Editar: [false, [Validators.required]],
      Ver: [false, [Validators.required]]
    });


  }

  ngOnInit() {}

  cancelarcreacion() {
    this.creacionFinalizada.emit();
  }

  async onSubmit() {
    if (this.usuarioForm.valid) {

      this.usuarioForm.value.IdEncuesta = this.IdEncuesta;

      this.data.CrearUsuario(this.usuarioForm.value).subscribe(response => {
        console.log(response);
        this.messageService.add({severity:'success', summary: 'Éxito', detail: 'Usuario creado exitosamente'});
        this.IdEncuesta=response.id;
        this.creacionFinalizada.emit();
      }, error => {
        console.error('Error al crear la encuesta:', error);
        console.log(error);
        this.messageService.add({severity:'error', summary: 'Error', detail: 'Error al crear la encuesta. Inténtelo nuevamente.'});
      });
    } else {
      console.log('Formulario no válido');
    }
  }

  get controls() {
    return this.usuarioForm.controls;
  }
}

